
    import './styles.scoped.css';
    export default {
  "root": "awsui_root_14iqq_1dn1p_3",
  "variant-default": "awsui_variant-default_14iqq_1dn1p_14",
  "variant-stacked": "awsui_variant-stacked_14iqq_1dn1p_14",
  "header": "awsui_header_14iqq_1dn1p_37",
  "header-sticky-disabled": "awsui_header-sticky-disabled_14iqq_1dn1p_41",
  "header-sticky-enabled": "awsui_header-sticky-enabled_14iqq_1dn1p_45",
  "header-stuck": "awsui_header-stuck_14iqq_1dn1p_50",
  "with-divider": "awsui_with-divider_14iqq_1dn1p_54",
  "header-dynamic-height": "awsui_header-dynamic-height_14iqq_1dn1p_58",
  "with-paddings": "awsui_with-paddings_14iqq_1dn1p_64",
  "content": "awsui_content_14iqq_1dn1p_68",
  "footer": "awsui_footer_14iqq_1dn1p_75"
};
  